package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.article_component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ArticleSortEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ListingLayoutsEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.WaiterDeviceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.GetCategory
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.article_component.desktop.DesktopWaiter
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.article_component.mobile.mobile_waiter_list_type.MobileWaiterListLayout
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.article_component.mobile.mobile_waiter_tiles.MobileWaiterTilesLayout

@Composable
fun ArticlePreviewForMWAndDW(
    windowSizeMode: WindowSizeModeEnum,
    articleRowsCount: Int,
    articleColumnsCount:Int,
    selectedArticleSortingId: String,
    productId: MutableState<String>,
    selectedDeviceType: WaiterDeviceTypeEnum,
    selectedLayoutType: ListingLayoutsEnum,
    selectedCategory: GetCategory?,
    currencyType: CurrencyTypeEnum,
    showImgUrl: suspend (String) -> String,
    deleteGridProduct: (Int) -> Unit,
    setGridProduct: (String, Int) -> Unit,
    updateListAfterDragAndDrop: (List<dynamic>, List<String>, List<Int>, List<String>) -> Unit,
) {
    val manualSorting=selectedArticleSortingId==ArticleSortEnum.MANUAL.sortId
    val manualItemsCount=articleRowsCount*articleColumnsCount

    val listingLayoutsChunk=if (manualSorting) articleColumnsCount else 1
    val tilesLayoutsChunk= if (manualSorting) articleColumnsCount
        else if (windowSizeMode== WindowSizeModeEnum.Desktop) 3
        else 2
    val desktopWaiterListChunk=when(windowSizeMode) {
        WindowSizeModeEnum.Desktop ->if (manualSorting) articleColumnsCount else 6
        WindowSizeModeEnum.TABLET ->if (manualSorting) articleColumnsCount else 2
        WindowSizeModeEnum.PHONE->if (manualSorting) articleColumnsCount else 2
    }
    val maxItems=Constants.maxArticleItems

    Column(
        modifier = VerticalScrollBehavior.toModifier()
            .thenIf(
                windowSizeMode== WindowSizeModeEnum.Desktop,
                Modifier.margin(right = Dimen.semiExtraLargePadding)
            )
            .borderSetting()
            .fillMaxWidth()
            .fillMaxHeight()
            .thenIf(
                windowSizeMode!= WindowSizeModeEnum.Desktop,
                    Modifier
                        .height(Dimen.TemplateArticleListHeight)
            )
            .overflow(Overflow.Auto)
        ,
        horizontalAlignment = Alignment.CenterHorizontally,

    )
    {
        when(selectedDeviceType)
        {

            WaiterDeviceTypeEnum.MOBILE_WAITER->{
                when(selectedLayoutType){

                    ListingLayoutsEnum.LIST -> {

                        MobileWaiterListLayout(
                            windowSizeMode=windowSizeMode,
                            productId=productId,
                            manualItemsCount=manualItemsCount,
                            listingLayoutsChunk=listingLayoutsChunk,
                            maxItems=maxItems,
                            selectedArticleSortingId=selectedArticleSortingId,
                            selectedCategory=selectedCategory,
                            currencyType=currencyType,
                            showImgUrl={key:String->
                                showImgUrl(key)
                            },
                            deleteGridProduct={position:Int->
                                deleteGridProduct(position)
                            },
                            setGridProduct = {productId:String,position:Int->
                                setGridProduct(
                                    productId,position
                                )
                            },
                            onReorder = { newList, idList, positionList, productIdList ->
                                updateListAfterDragAndDrop(
                                    newList,
                                    idList,
                                    positionList,
                                    productIdList,
                                )
                            }
                        )

                    }

                    ListingLayoutsEnum.TILES->{


                        MobileWaiterTilesLayout(
                            productId=productId,
                            maxItems=maxItems,
                            selectedCategory=selectedCategory,
                            listingLayoutsChunk=tilesLayoutsChunk,
                            currencyType=currencyType,
                            manualItemsCount=manualItemsCount,
                            selectedArticleSortingId = selectedArticleSortingId,
                            showImgUrl={key:String->
                                showImgUrl(key)
                            },
                            deleteGridProduct = {position:Int->
                                deleteGridProduct(position)
                            },
                            setGridProduct = {productId:String,position:Int->
                                setGridProduct(
                                    productId,position
                                )
                            },
                            onReorder = { newList, idList, positionList, productIdList ->
                                updateListAfterDragAndDrop(
                                    newList,
                                    idList,
                                    positionList,
                                    productIdList,
                                )
                            },

                        )

                    }
                }
            }
            WaiterDeviceTypeEnum.DESKTOP_WAITER->{

                DesktopWaiter(
                    windowSizeMode=windowSizeMode,
                    productId=productId,
                    maxItems=maxItems,
                    selectedCategory=selectedCategory,
                    manualItemsCount=manualItemsCount,
                    selectedArticleSortingId = selectedArticleSortingId,
                    desktopWaiterListChunk=desktopWaiterListChunk,
                    showImgUrl={key:String->
                        showImgUrl(key)
                    },
                    deleteGridProduct={position:Int->
                        deleteGridProduct(position)
                    },
                    setGridProduct = {productId:String,position:Int->
                        setGridProduct(
                            productId,position
                        )
                    },
                    onReorder = { newList, idList, positionList, productIdList ->
                        updateListAfterDragAndDrop(
                            newList,
                            idList,
                            positionList,
                            productIdList,
                        )
                    },

                )

            }
        }

    }



}

